import {
    WALLET_TRANSACTIONS_STATEMENT_ERROR,
    WALLET_TRANSACTIONS_STATEMENT_LOAD,
    WALLET_TRANSACTIONS_STATEMENT_SUCCESS,
    WALLET_TRANSACTIONS_DETAIL_ERROR,
    WALLET_TRANSACTIONS_DETAIL_SUCCESS,
    WALLET_TRANSACTIONS_DETAIL_LOAD,
    WALLET_TRANSACTIONS_CONVERSION_ERROR,
    WALLET_TRANSACTIONS_CONVERSION_SUBMIT,
    WALLET_TRANSACTIONS_CONVERSION_SUCCESS,
    WALLET_TRANSACTIONS_FAVORITES_ERROR,
    WALLET_TRANSACTIONS_FAVORITES_LOAD,
    WALLET_TRANSACTIONS_FAVORITES_SUCCESS,
} from '../actionTypes'

import {
    getInfoLocalStorage,
    setInfoLocalStorage,
    destroyInfoLocalStorage
} from '../../utils/api'
import moment from 'moment'

const initialState = {
    isLoading: false,
    message: null,
    success: false,
    statement: [],
    details: [],
    conversionSubmit: false,
    conversionSuccess: false,
}

const stateFromLocalStorage = getInfoLocalStorage()


export default (state = initialState, action) => {
    switch(action.type) {

        case WALLET_TRANSACTIONS_CONVERSION_SUBMIT:
            return {
                ...state,
                conversionSubmit: true,
            }

        case WALLET_TRANSACTIONS_CONVERSION_SUCCESS:
            return {
                ...state,
                conversionSubmit: false,
                conversionSuccess: true,
                message: action.payload.message
            }

        case WALLET_TRANSACTIONS_CONVERSION_ERROR:
            return {
                ...state,
                message: action.payload.message,
                conversionSubmit: false,
                conversionSuccess: false
            }

        case WALLET_TRANSACTIONS_DETAIL_LOAD:
            return {
                ...state,
                isLoading: true
            }

        case WALLET_TRANSACTIONS_DETAIL_ERROR:
            return {
                ...state,
                isLoading: false,
                success: false,
                message: action.payload.message
            }

        case WALLET_TRANSACTIONS_DETAIL_SUCCESS:
            return {
                ...state,
                success: true,
                details: action.payload.details,
                isLoading: false,
                message: null
            }

        case WALLET_TRANSACTIONS_STATEMENT_LOAD:
            return {
                ...state,
                isLoading: true
            }

        case WALLET_TRANSACTIONS_STATEMENT_ERROR:
            return {
                ...state,
                isLoading: false
            }

        case WALLET_TRANSACTIONS_STATEMENT_SUCCESS:
            return {
                ...state,
                success: true,
                isLoading: false,
                statement: action.payload.statement
            }

        case WALLET_TRANSACTIONS_FAVORITES_LOAD:
            return {
                ...state,
                isLoading: true
            }
    
        case WALLET_TRANSACTIONS_FAVORITES_ERROR:
            return {
                ...state,
                success: false, 
                isLoading: false
            }
    
        case WALLET_TRANSACTIONS_FAVORITES_SUCCESS:
            return {
                ...state,
                success: true,
                isLoading: false,
                favorites: action.payload.favorites
            }

        default:
            return state
    }
}